import Select from './src/select.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpSelect = withInstall(Select)
export default EpSelect
export * from './src/select'
